import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const reportRoutePermissions = {
  '/reports/monthly-wqi': 'report:monthly-wqi',
  '/reports/compare-2y': 'report:compare-2y',
  '/reports/exceedance': 'report:exceedance',
  '/reports/river-compare': 'report:river-compare',
  '/reports/river-vs-river': 'report:river-vs-river',
  '/reports/river-longitudinal': 'report:river-longitudinal',
};
const getStationIdFromPath = (pathname) => {
  const match = pathname.match(/^\/station\/(\d+)$/);
  return match ? match[1] : null;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user, hasAccess, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="App">
        <div className="auth-container">
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="pulse" style={{ fontSize: '18px', color: '#667eea' }}>
              Loading...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Users page — permission-based (Super Admin always allowed)
  if (location.pathname.startsWith('/users') && !isAdmin && !hasAccess('users:dashboard')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Restrict report pages by report permissions
  const requiredPermission = reportRoutePermissions[location.pathname];
  if (requiredPermission && !isAdmin && !hasAccess(requiredPermission)) {
    return <Navigate to="/dashboard" replace />;
  }
const stationId = getStationIdFromPath(location.pathname);
if (stationId && !isAdmin && !hasAccess('stations') && !hasAccess(`station:${stationId}`)) {
  return <Navigate to="/dashboard" replace />;
}
  return children;
};

export default ProtectedRoute;
